<h1 class="page-title w-50"> قطاع الغزل والنسيج
</h1>
<div class="pb-5">
  <div class="d-flex justify-content-between">
    <div class="share-section mb-4 w-50 pt-5">
      <div class="share-text mb-2">شارك المقال على</div>
      <div class="social-icons d-flex justify-content-end gap-2">
        <a href="#" class="social-icon">
          <i class="fa-brands fa-twitter"></i>
        </a>
        <a href="#" class="social-icon">
          <i class="fa-brands fa-facebook-f"></i>
        </a>
      </div>
    </div>
  </div>
  <div class="container-fluid">
    <div class="banner-container">
      <img src="../../../assets/Textiles-banner.jpg" alt=" " class="banner-image" />
      <div class="growth-badge">
        <span> صناعة الغزل والنسيج المتكامل الوحيد بالكامل في الشرق الأوسط

        </span>
      </div>
    </div>

    <div class="sector-content">
      <p> قطاع الغزل والنسيج
      </p>
      <hr />
      <p> عن قطاع الغزل والنسيج
        : </p>
      <p>
        يُعد قطاع الغزل والنسيج​ من أهم القطاعات الصناعية التي تُساهم بدور بارز في الاقتصاد القومي المصري، نظراً لما
        تتمتع به مصر في هذه الصناعة من ميزة نسبية كبيرة، وشهرتها العالمية في المادة الخام (القطن) ذات الجودة العالية.كما
        تُعد صناعة المنسوجات والملابس ثاني​ أكبر القطاعات الصناعية في مصر بعد الصناعات الغذائية، وتلعب أيضاً صناعة الغزل
        والنسيج دوراً رئيسياً في تشكيل الاقتصاد المصري، كما تم توجيه صناعة المنسوجات المصرية لتكون مورداً رئيسياً لمواد
        النسيج الأولية للملابس، ومُصنّعي المنسوجات المنزلية، والعديد من الاستخدامات الأخرى محلياً وعالمياً.​

      </p>
      <a href="https://www.investinegypt.gov.eg/Arabic/Pages/exploreMap.aspx?secId=99">لمزيد من المعلومات اضغط هنا</a>
    </div>
  </div>
</div>